import { combineReducers } from 'redux';
import { getJSON } from 'redux-api-middleware';

import apiGenerator from '../apiGenerator';
import User, { userToApiMap } from '../../models/User';
import { mapApiToModel } from '../../models/modelMapper';

// Actions
const USER_LOGIN_REQUEST = 'ctm/auth/USER_LOGIN_REQUEST';
const USER_LOGIN_SUCCESS = 'ctm/auth/USER_LOGIN_SUCCESS';
const USER_LOGIN_FAILURE = 'ctm/auth/USER_LOGIN_FAILURE';

const USER_LOGOUT_REQUEST = 'ctm/auth/USER_LOGOUT_REQUEST';
export const USER_LOGOUT_SUCCESS = 'ctm/auth/USER_LOGOUT_SUCCESS';
const USER_LOGOUT_FAILURE = 'ctm/auth/USER_LOGOUT_FAILURE';

const SIGNUP_NEW_USER_REQUEST = 'ctm/auth/SIGNUP_NEW_USER_REQUEST';
const SIGNUP_NEW_USER_SUCCESS = 'ctm/auth/SIGNUP_NEW_USER_SUCCESS';
const SIGNUP_NEW_USER_FAILURE = 'ctm/auth/SIGNUP_NEW_USER_FAILURE';

const UPDATE_USER_REQUEST = 'ctm/auth/UPDATE_USER_REQUEST';
const UPDATE_USER_SUCCESS = 'ctm/auth/UPDATE_USER_SUCCESS';
const UPDATE_USER_FAILURE = 'ctm/auth/UPDATE_USER_FAILURE';

const FORGOT_PASSWORD_REQUEST = 'ctm/auth/FORGOT_PASSWORD_REQUEST';
const FORGOT_PASSWORD_SUCCESS = 'ctm/auth/FORGOT_PASSWORD_SUCCESS';
const FORGOT_PASSWORD_FAILURE = 'ctm/auth/FORGOT_PASSWORD_FAILURE';

const RESET_PASSWORD_REQUEST = 'ctm/auth/RESET_PASSWORD_REQUEST';
const RESET_PASSWORD_SUCCESS = 'ctm/auth/RESET_PASSWORD_SUCCESS';
const RESET_PASSWORD_FAILURE = 'ctm/auth/RESET_PASSWORD_FAILURE';

// Action Creators
export function login(email, password, onSuccess, onFailure) {
  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: 'signin',
      method: 'POST',
      body: {
        email,
        password,
      },
      types: [USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAILURE],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

export function logout() {
  return apiGenerator({
    endpoint: 'signout',
    method: 'POST',
    types: [USER_LOGOUT_REQUEST, USER_LOGOUT_SUCCESS, USER_LOGOUT_FAILURE],
  });
}

export function doSignup(newUser, onSuccess, onFailure) {
  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: 'user',
      method: 'POST',
      body: {
        first: newUser.firstName,
        last: newUser.lastName,
        email: newUser.email,
        username: newUser.email,
        password: newUser.password,
        currancy: 'USD',
      },
      isProtected: false,
      types: [SIGNUP_NEW_USER_REQUEST, SIGNUP_NEW_USER_SUCCESS, SIGNUP_NEW_USER_FAILURE],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

export function doForgotPassword(emailAddress, onSuccess, onFailure) {
  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: 'forgot-password',
      method: 'POST',
      body: {
        email: emailAddress,
      },
      isProtected: false,
      types: [FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

export function doResetPassword(newPassword, nonceToken, onSuccess, onFailure) {
  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: 'reset-password',
      method: 'POST',
      body: {
        token: nonceToken,
        password: newPassword,
      },
      isProtected: false,
      types: [RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

export function updateUser(updatedUser, onSuccess, onFailure) {
  const userObj = {
    id: updatedUser.id,
    first: updatedUser.firstName,
    last: updatedUser.lastName,
    email: updatedUser.email,
    username: updatedUser.email,
    tempAvatarUploadName: updatedUser.tempAvatarUploadName,
    currancy: 'USD',
  };

  if (updatedUser.newPassword && updatedUser.newPassword === updatedUser.confirmPassword) {
    userObj.password = updatedUser.newPassword;
  }

  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: `user/${userObj.id}`,
      method: 'put',
      body: userObj,
      types: [
        UPDATE_USER_REQUEST,
        {
          type: UPDATE_USER_SUCCESS,
          payload: (action, state, res) =>
            getJSON(res).then(json => mapApiToModel(json, userToApiMap, User)),
        },
        UPDATE_USER_FAILURE,
      ],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

// Reducers
export function user(state = new User(), action) {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return mapApiToModel(action.payload.user, userToApiMap, User);
    case UPDATE_USER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function sessionToken(state = '', action) {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return action.payload.session;
    default:
      return state;
  }
}

export function isSigningIn(state = false, action) {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      if (action.error) return false;
      return true;
    case USER_LOGIN_SUCCESS:
    case USER_LOGIN_FAILURE:
      return false;
    default:
      return state;
  }
}

export function isUpdatingUser(state = false, action) {
  switch (action.type) {
    case UPDATE_USER_REQUEST:
      if (action.error) return false;
      return true;
    case UPDATE_USER_SUCCESS:
    case UPDATE_USER_FAILURE:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  sessionToken,
  user,
  isSigningIn,
  isUpdatingUser,
});



// WEBPACK FOOTER //
// ./src/redux/ducks/auth.js